const publicationsData = {

"journals": [
    {
        "citation": "Wiafe, I., Ekpezu, A. O., Gyamera, G. O., Winful, F. B. P., Atsakpo, E. D., Nutrokpor, C., & Gulliver, S. R. (2025). Comparative evaluation of learning technologies using a randomized controlled trial: Virtual reality, augmented reality, online video platforms, and traditional classroom learning. Education and Information Technologies.",
        "year":"2025",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Ekpezu, A. O., Gyamera, G. O., Winful, F. B. P., Atsakpo, E. D., Nutrokpor, C., & Gulliver, S. R. (2024). Learning satisfaction in virtual reality: The role of persuasive design. International Journal of Human-Computer Interaction.",
        "year":"2024",
        "status": ""
      },
      
      {
        "citation": "Ekpezu, A. O., Wiafe, I., & Oinas-Kukkonen, H. (2024). Persuasive software features as antecedents to perceived compliance within physical activity behavior change support systems. Behaviour & Information Technology.",
        "year":"2024",
        "status": ""
      },

      {
        "citation": "Ekpezu, A. O., Wiafe, I., & Oinas-Kukkonen, H. (2023). Predicting adherence to behavior change support systems using machine learning: Systematic review. Journal of Medical Internet Research - Artificial Intelligence.",
        "year":"2023",
        "status": ""
      },

      {
        "citation": "Ekpezu, A. O., Wiafe, I., & Oinas-Kukkonen, H. (2023). Enhancing perceived health competence: The impact of persuasive social support features in health and fitness apps. International Journal of Human-Computer Interaction",
        "year":"2023",       
        "status": ""
      },

      {
        "citation": "Wiafe, A., Nutrokpor, C., Owusu, E., Kastriku, F. A., & Wiafe, I. (2022). Using genetic algorithms for music composition: Implications of early termination on aesthetic quality. International Journal of Information Technology",
        "year":"2022",
        "status": ""
      },

      {
        "citation": "Armah, Z. A., Wiafe, I., Koranteng, F. N., & Owusu, E. (2022). Speed monitoring and controlling systems for road vehicle safety: A systematic review. Advances in Transportation Studies.",
        "year": "2022",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Koranteng, F. N., Kastriku, F. A., & Gyamera, G. O. (2022). Assessing the impact of persuasive features on user’s intention to continuous use: The case of academic social networking sites. Behaviour & Information Technology.",
        "year": "2022",
        "status": ""
      },
      {
        "citation": "Ekpezu, A. O., Katsriku, F., Yaokumah, W., & Wiafe, I. (2022). The use of machine learning algorithms in the classification of sound: A systematic review. International Journal of Service Science, Management, Engineering, and Technology.",
        "year": "2022",
        "status": ""
      },
      {
        "citation": "Koranteng, F. N., Ham, J., Wiafe, I., & Matzat, U. (2022). The role of usability, aesthetics, usefulness and primary task support in predicting the perceived credibility of academic social networking sites. Behaviour & Information Technology.",
        "year": "2022",
        "status": ""
      },
      {
        "citation": "Ekpezu, A. O., Wiafe, I., Katsriku, F., & Yaokumah, W. (2021). Using deep learning for acoustic event classification: The case of natural disasters. The Journal of the Acoustical Society of America.",
        "year": "2021",
        "status": ""
      },
      {
        "citation": "Owusu, E., & Wiafe, I. (2021). An advanced ensemble classification for object recognition. Neural Computing and Applications.",
        "year": "2021",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Koranteng, F. N., Owusu, E., & Alimo, S. (2021). Factors that influence user perception of ubiquitous monitoring environments: An empirical study in a developing country. Journal of Ambient Intelligence and Smart Environments.",
        "year": "2021",
        "status": ""
      },
      {
        "citation": "Banaseka, F. K., Franklin, H., Katsriku, F. A., Abdulai, J.-D., Ekpezu, A., & Wiafe, I. (2021). Soil medium electromagnetic scattering model for the study of wireless underground sensor networks. Wireless Communications and Mobile Computing.",
        "year": "2021",
        "status": ""
      },
      {
        "citation": "Yaokumah, W., & Wiafe, I. (2020). Analysis of machine learning techniques for anomaly-based intrusion detection. International Journal of Distributed Artificial Intelligence.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Koranteng, F. N., Wiafe, A., Obeng, E. N., & Yaokumah, W. (2020). The role of norms in information security policy compliance. Information and Computer Security.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Koranteng, F. N., Wiafe, I., Katsriku, F. A., & Apau, R. (2020). Understanding trust on social networking sites among tertiary students: An empirical study in Ghana. Applied Computing and Informatics.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Koranteng, F. N., Obeng, E. N., Assyne, N., Wiafe, A., & Gulliver, S. R. (2020). Artificial intelligence for cybersecurity: A systematic mapping of literature. IEEE Access.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Koranteng, F. N., Owusu, E., Ekpezu, A. O., & Gyamfi, S. A. (2020). Persuasive social features that promote knowledge sharing among tertiary students on social networking sites: An empirical study. Journal of Computer Assisted Learning.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Abdulai, J. D., Katsriku, F., Kumi, J. A., Koranteng, F. N., & Boakye-Sekyerehene, P. (2020). Controlling driver overspeeding with a persuasive and intelligent road marking system. Advances in Transportation Studies.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Koranteng, F. N., Tettey, T., Kastriku, F. A., & Abdulai, J.-D. (2020). Factors that affect acceptance and use of information systems within the maritime industry in developing countries: The case of Ghana. Journal of Systems and Information Technology.",
        "year": "2020",
        "status": ""
      },
      {
        "citation": "Koranteng, F. N., Wiafe, I., & Kuada, E. (2019). An empirical study of the relationship between social networking sites and students’ engagement in higher education. Journal of Educational Computing Research.",
        "year": "2019",
        "status": ""
      },
      {
        "citation": "Koranteng, F. N., & Wiafe, I. (2019). Factors that promote knowledge sharing on academic social networking sites: An empirical study. Education and Information Technologies.",
        "year": "2019",
        "status": ""
      },
      {
        "citation": "Debrah, E. O., Abdulai, J. D., Wiafe, I., & Katsriku, F. A. (2018). Design and implementation of an integrated web application for the Motor Traffic and Transport Directorate of the Ghana Police Service. Science and Development.",
        "year": "2018",
        "status": ""
      },
      {
        "citation": "Afful, E., Adu-Manu, K. S., Yamoah, G. G., Abdulai, J. D., Gyamfi, N. K., Adjei, E., Wiafe, I., & Katsriku, F. A. (2018). Redefining the concept of big data: A Ghanaian perspective. Science and Development.",
        "year": "2018",
        "status": ""
      },
      {
        "citation": "Wiafe, I., Nakata, K., & Gulliver, S. (2014). Categorizing users in behavior change support systems based on cognitive dissonance. Personal and Ubiquitous Computing.",
        "year": "2014",
        "status": ""
      },
      {
        "citation": "Wiafe, I. (2014). U-FADE: A unified approach to persuasive systems development. International Journal of Conceptual Structures and Smart Applications.",
        "year": "2014",
        "status": ""
      },
      {
        "citation": "Gulliver, S., Grzybek, H., Radosavljevic, M., & Wiafe, I. (2013). Changing building user attitude and organizational policy towards sustainable resource use in healthcare. Health Policy and Technology.",
        "year": "2013",
        "status": ""
      },
      
    ],

        "conferences": [
            {
                "citation": "Ekpezu, A., Nutrokpor, C., Wiafe, I., & Oinas-Kukkonen, H. (2024). Examining continuance intention to exercise in a virtual reality environment. Proceedings of the 57th Annual Hawaii International Conference on System Sciences.",
                "year":"2024",
                "status": ""
              },
              {
                "citation": "Ekpezu, A. O., Wiafe, I., & Oinas-Kukkonen, H. (2024). Technological factors that influence user compliance with behavior change support systems: A systematic review. Proceedings of the 57th Annual Hawaii International Conference on System Sciences.",
                "year":"2024",
                "status": ""
              },

              {
                "citation": "Wiafe, I., Doe Atsakpo, E., Nutrokpor, C., Ham, J., & Gulliver, S. (2023). Design and evaluation of a persuasive road marking system for controlling speeding behavior. Proceedings of the International Academic Mindtrek Conference.",
                "year":"2023",
                "status": ""
              },
              {
                "citation": "Ekpezu, A. O., Oinas-Kukkonen, H., & Wiafe, I. (2023). Investigating the determinants of compliance intention in behavior change support systems. AMCIS 2023 Proceedings.",
                "year":"2023",
                "status": ""
              },
              {
                "citation": "Koranteng, F. N., Matzat, U., Wiafe, I., & Ham, J. (2023). Credibility in persuasive systems: A systematic review. Lecture Notes in Computer Science",
                "year":"2021",
                "status": ""
              },
              {
                "citation": "Koranteng, F. N., Ham, J., Matzat, U., & Wiafe, I. (2022). Supporting to be credible: Investigating perceived social support as a determinant of perceived credibility. Lecture Notes in Computer Science.",
                "year": "2022",
                "status": ""
              },
              {
                "citation": "Nutrokpor, C., Ekpezu, A. O., Wiafe, A., & Wiafe, I. (2021). Exploring the impact of persuasive system features on user sentiments in health and fitness apps. CEUR Proceedings.",
                "year": "2021",
                "status": ""
              },
              {
                "citation": "Alhammad, M. M., Wiafe, I., & Gulliver, S. R. (2021). Exploring the impact of persuasive features on customer satisfaction levels of E-Commerce Websites Based on the Kano Model. Lecture Notes in Computer Science.",
                "year": "2021",
                "status": ""
              },
              {
                "citation": "Koranteng, F. N., Ham, J., & Wiafe, I. (2021). Investigating user perceptions of persuasive design elements that influence perceived credibility. Lecture Notes in Computer Science.",
                "year": "2021",
                "status": ""
              },
              {
                "citation": "Assyne, N., & Wiafe, I. (2019). A dynamic software startup competency model. Lecture Notes in Business Information Processing.",
                "year": "2019",
                "status": ""
              },
              {
                "citation": "Wiafe, I., Abdulai, J. D., Arkligo, M. A., & Kumi, J. A. (2018). Persuading vehicular drivers to avoid overspeeding using intelligent road markings. CBAS - Science and Development Platform.",
                "year": "2018",
                "status": ""
              },
              {
                "citation": "Dabi, J., Wiafe, I., Stibe, A., & Jamal-Deen, A. (2018). Can an enterprise system persuade? The role of perceived effectiveness and social influence. Lecture Notes in Computer Science.",
                "year": "2018",
                "status": ""
              },
              {
                "citation": "Kuada, E., Wiafe, I., Addo, D., & Djaba, E. (2017). Privacy-enhancing national identification card system. AFRICON IEEE.",
                "year": "2017",
                "status": ""
              },
              {
                "citation": "Wiafe, I., Addo, D., Assyne, N., & Wiafe, A. (2016). Assessing the relationship between user perception and use of ERPs in higher education institutions in Ghana. Applied Informatics and Technology Innovation Conference.",
                "year": "2016",
                "status": ""
              },
              {
                "citation": "Wiafe, I., & Frempong, D. A. (2015). Enhancing persuasive features of behaviour change support systems: The role of U-FADE. International Workshop on Behaviour Change Support System.",
                "year": "2015",
                "status": ""
              },
              {
                "citation": "Wiafe, I. (2013). A unified framework for analyzing, designing, and evaluating persuasive technologies. EuroPLOT.",
                "year": "2013",
                "status": ""
              },
              {
                "citation": "Alhammad, M., Gulliver, S., Wiafe, I., & Nakata, K. (2013). Culture, cognition, and e-commerce behavior. Proceedings of ICISO 2013.",
                "year": "2013",
                "status": ""
              },
              {
                "citation": "Wiafe, I., & Nakata, K. (2013). Bibliographic analysis of persuasive systems: Techniques, methods, and domains of application. CEUR Proceedings.",
                "year": "2013",
                "status": ""
              },
              {
                "citation": "Wiafe, I., Alhammad, M. M., Nakata, K., & Gulliver, S. R. (2012). Analyzing the persuasion context of the persuasive systems design model with the 3D-RAB model. Lecture Notes in Computer Science.",
                "year": "2012",
                "status": ""
              },
              {
                "citation": "Wiafe, I., Nakata, K., & Gulliver, S. R. (2011). Designing persuasive third-party applications for social networking services based on the 3D-RAB model. Communications in Computer and Information Science.",
                "year": "2011",
                "status": ""
              },
              {
                "citation": "Grzybek, H., Shah, H., Wiafe, I., Gulliver, S., & Nakata, K. (2011). Modelling building semantics: Providing feedback and sustainability. Proceedings of World Renewable Energy Congress.",
                "year": "2011",
                "status": ""
              },
              {
                "citation": "Wiafe, I., Nakata, K., Moran, S., & Gulliver, S. (2011). Considering user attitude and behavior in persuasive systems design: The 3D-RAB model. Proceedings of ECIS 2011.",
                "year": "2011",
                "status": ""
              },
              {
                "citation": "Moran, S., Wiafe, I., & Nakata, K. (2011). Ubiquitous monitoring as a tool for changing cognitive state. IEEE/WIC/ACM.",
                "year": "2011",
                "status": ""
              },
              {
                "citation": "Wiafe, I., & Nakata, K. (2010). A semiotic analysis of persuasive technology: An application to obesity management. Proceedings from ICISO 2010.",
                "year": "2010",
                "status": ""
              }
        ],
        "book_chapters":[
          {
            "citation": "Gulliver, S. R., Wiafe, I., Grzybek, H., & Radosavljevic, M. (2014). Healthcare resource sustainability: Obtaining information access via healthcare space modelling. Handbook of Research on Patient Safety and Quality Care through Health Informatics.",
            "year": "2014",
            "status": ""
          },
          {
            "citation": "Gulliver, S. R., Wiafe, I., Grzybek, H., & Radosavljevic, M. (2014). Healthcare resource sustainability: Obtaining information access via healthcare space modelling. Handbook of Research on Patient Safety and Quality Care through Health Informatics.",
            "year": "2014",
            "status": ""
          },
          {
            "citation": "Wiafe, I. (2018). The role of U-FADE in selecting persuasive system features. Encyclopedia of Information Science and Technology.",
            "year": "2018",
            "status": ""
          },
          {
            "citation": "Wiafe, I., Yaokumah, W., & Kissi, F. A. (2020). Students' intentions on cyber ethics issues. Modern Theories and Practices for Cyber Ethics and Security Compliance.",
            "year": "2020",
            "status": ""
          },
          {
            "citation": "Yaokumah, W., Rajarajan, M., Abdulai, J., Wiafe, I., & Katsriku, F. A. (2020). Modern Theories and Practices for Cyber Ethics and Security Compliance. IGI Global.",
            "year": "2020",
            "status": ""
          }
        ]
}

export default publicationsData